import { takeLatest, call, put } from 'redux-saga/effects';
import { PUT_ABOUT_US_START, PUT_ABOUT_US_ERROR, PUT_ABOUT_US_SUCCESS, GET_ABOUT_US_START } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/about-us/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_ABOUT_US_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_ABOUT_US_ERROR, error });
  } finally {
    yield put({ type: GET_ABOUT_US_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1)
  }
}

export default function* put_about_us() {
  yield takeLatest(PUT_ABOUT_US_START, edit);
}
